import { FC } from 'react';
import { Character } from '../../data/characters';

interface MatchResult {
  id: string;
  date: Date;
  playerCharacter: Character;
  opponentCharacter: Character;
  result: 'win' | 'loss';
  turns: number;
}

interface MatchHistoryProps {
  matches: MatchResult[];
  onViewMatch?: (matchId: string) => void;
}

const MatchHistory: FC<MatchHistoryProps> = ({ matches, onViewMatch }) => {
  return (
    <div className="bg-gray-800 rounded-lg p-4">
      <h3 className="text-xl font-bold mb-4">Match History</h3>
      <div className="space-y-2">
        {matches.map(match => (
          <div
            key={match.id}
            className={`p-3 rounded ${
              match.result === 'win' ? 'bg-green-900/50' : 'bg-red-900/50'
            } flex items-center justify-between`}
          >
            <div className="flex items-center space-x-4">
              <img
                src={match.playerCharacter.imageUrl}
                alt={match.playerCharacter.name}
                className="w-10 h-10 rounded-full"
              />
              <div className="text-2xl font-bold">VS</div>
              <img
                src={match.opponentCharacter.imageUrl}
                alt={match.opponentCharacter.name}
                className="w-10 h-10 rounded-full"
              />
            </div>
            <div className="flex flex-col items-end">
              <span className={`font-bold ${
                match.result === 'win' ? 'text-green-500' : 'text-red-500'
              }`}>
                {match.result.toUpperCase()}
              </span>
              <span className="text-sm text-gray-400">
                {match.turns} turns • {match.date.toLocaleDateString()}
              </span>
            </div>
            {onViewMatch && (
              <button
                onClick={() => onViewMatch(match.id)}
                className="ml-4 px-3 py-1 bg-blue-600 hover:bg-blue-700 
                rounded text-sm transition-colors"
              >
                View
              </button>
            )}
          </div>
        ))}
      </div>
      {matches.length === 0 && (
        <div className="text-center text-gray-500 py-4">
          No matches played yet
        </div>
      )}
    </div>
  );
};

export default MatchHistory; 